import usertagEdit from './edit.vue'
import usertagList from './list.vue'

let a = Object.assign({ usertagEdit, usertagList})
export default a;